import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Grid,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TableHead,
  InputAdornment,
  Chip,
  Select as MaterialUISelect,
  MenuItem,
  FormControl,
  InputLabel,
  TextField, // DP_DATE_FILTER : Imports Material UI TextField to provide the start-date and end-date selection controls.
} from "@material-ui/core";
import { Dialog } from "../../components/Dialog";

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import ActionButton from "../../components/controls/ActionButton";
import VisibilityIcon from '@material-ui/icons/Visibility';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import SettingsIcon from '@material-ui/icons/Settings';
import SyncIcon from '@material-ui/icons/Sync';
import PropTypes from "prop-types";
import clsx from "clsx";
import { getDispatchOrderList, getDispatchPlanReport, getSalesOrderFile, getSAPDataForDispatchPlan, saveSAPData, syncSingleDispatchPlanWithSAP } from "../../services/dispatchPlan";
import Input from "../../components/controls/Input";
import { Search } from "@material-ui/icons";

import { lighten, makeStyles } from "@material-ui/core/styles";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { getCurrentUser } from '../../services/userService'
import { STATUS, STATUS_TEXT, USER_TYPES } from "../../constants";
import { formatDate } from "../../helpers/helperFunctions";
import SelectDistributorAndPO from "./SelectDistributorAndPO";
import EditSalesOrderDetails from "./EditSalesOrderDetails";
import Notifications from "../../components/Notifications";
import UploadInvoiceData from "./UploadInvoiceData";
import { useStyles as useDPStyles } from "./styles";
import UploadReportFile from "./UploadReportFile";
import DownloadReport from "./DownloadReport";
function createData(id, date, org_name, ref_no, po_ref_no, sap_sales_order_id, sales_order_filename, total_materials, total_quantity, status, created_by, sap_quantity, sap_sales_order_no) {
  return { 
    id, date, org_name, ref_no, po_ref_no, sap_sales_order_id, sales_order_filename, 
    total_materials, total_quantity, status, created_by, sap_quantity, sap_sales_order_no 
  };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
const cssStyles = ((theme) => ({
  pageContent: {
    // margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,

  searchInput: {
    width: "58%",
    marginLeft: "18px",
    marginRight: "12px"
  },
  exportButton: {
    position: "relative",
    fontSize: "12px"
  },
  bookOrderButton: {
    position: "relative",
    fontSize: "12px",
    whiteSpace: "nowrap"
  },
  acceptButton: {
    position: "relative",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: '#4caf50',
    '&:hover': {
      backgroundColor: "#139018",
    },
  },
  rejectButton: {
    position: "relative",
    fontSize: "12px",
    whiteSpace: "nowrap"
  },
  container: {
    display: "block",
    maxWidth: "85vw",
    overflowX: "auto",
    marginRight: "auto",
    marginLeft: "auto",
    padding: "2px",
    margin: "5px",
    fontSize: "12px",
  },
  textDark: {
    fontWeight: "500",
    fontSize: "15px",
    lineHeight: "18px",
    color: "#323232",
    opacity: "0.99",
  },
  inProgress: {
    color: '#155724',
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb',
    border: 0,
    padding: '6px 9px',
    fontWeight: 'bold',
  },
  rejected: {
    color: '#721c24',
    backgroundColor: '#f8d7da',
    borderColor: '#f5c6cb',
    border: 0,
    padding: '6px 9px',
    fontWeight: 'bold',
  },
  pending: {
    color: '#856404',
    backgroundColor: '#fff3cd',
    borderColor: '#ffeeba',
    border: 0,
    padding: '6px 9px',
    fontWeight: 'bold',
  },
  completed: {
    color: '#fff',
    backgroundColor: '#007bff',
    borderColor: '#ffeeba',
    border: 0,
    padding: '6px 9px',
    fontWeight: 'bold',
  },
  approved: {
    color: '#fff',
    backgroundColor: '#17a2b8',
    borderColor: '#ffeeba',
    border: 0,
    padding: '6px 9px',
    fontWeight: 'bold',
  },
  tableContainer: {
    minHeight: '400px',
  }
}));
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "organizations_name",
    numeric: true,
    disablePadding: false,
    label: "Organizations Name",
  },
  { id: "ref_no", numeric: true, disablePadding: false, label: "DP Ref No" },
  { id: "po_ref_no", numeric: true, disablePadding: false, label: "PO Ref No" },
  {
    id: "sap_sales_order_id",
    numeric: true,
    disablePadding: false,
    label: "Sales Order ID",
  },
  {
    id: "total_materials",
    numeric: true,
    disablePadding: false,
    label: "Total Materials",
  },
  {
    id: "total_quantity",
    numeric: true,
    disablePadding: false,
    label: "Total Quantity",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },

  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
           padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    // minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  pageContent: {
    // margin: theme.spacing(3),
    padding: theme.spacing(1),
  },
  toolbar: theme.mixins.toolbar,

  textCenter: {
    textAlign: "center",
  },
  container: {
    display: "block",
    maxWidth: "85vw",
    overflowX: "auto",
    marginRight: "auto",
    marginLeft: "auto",
    padding: "10px",
    margin: "10px",
  },
}));


const DispatchPlanList = (props) => {
  const history = useHistory();

    // DP_DATE_FILTER : Calculates the default financial-year date range and maintains the selected and applied date values.
    const getDateInputValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const today = new Date();

  const defaultEndDate = getDateInputValue(today);

  const financialYearStart = new Date(
    today.getFullYear() - (today.getMonth() < 3 ? 1 : 0),
    3,
    1
  );

  const defaultStartDate = getDateInputValue(financialYearStart);

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  const [appliedStartDate, setAppliedStartDate] = useState(defaultStartDate);
  const [appliedEndDate, setAppliedEndDate] = useState(defaultEndDate);

  const [searchTerm, setSearchTerm] = useState('');
  //end

  const [rows, setRows] = useState([]);
  const [stableData, setStableData] = useState([]);
const [completeData, setCompleteData] = useState([]);  // ADD THIS MISSING STATE
const [isSearching, setIsSearching] = useState(false);  // ADD THIS MISSING STATE (optional)
const [searchResults, setSearchResults] = useState([]); 


  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });


  const classes = useStyles();
  const dpClasses = useDPStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("date");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  // const [openPopUpReject, setopenPopUpReject] = React.useState(false)
  const [filterSelected, setFilterSelected] = useState(-1);
  
  const [openPopUp, setOpenPopUp] = useState(false);
  const [openInvoicePopUp, setOpenInvoicePopUp] = useState(false);
  const [openSalesOrderPopUp, setOpenSalesOrderPopUp] = useState(false);
  const [openReportUploadPopUp, setOpenReportUploadPopUp] = useState(false);
  const [downloadReportPopUp, setDownloadReportPopUp] = useState(false);
  const [dpForSalesOrder, setDpForSalesOrder] = useState(null);
  const [sapDataMap, setSapDataMap] = useState({});  // for SAP
const [sapFetching, setSapFetching] = useState(false);  // for SAP
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  });

  const [isSyncing, setIsSyncing] = useState(false);
  const syncedRowsRef = React.useRef(new Set());

  const [rejectReason, setrejectReason] = React.useState('')
  const [orderId, setOrderId] = useState()
  const [user, setUser] = useState()
  const [currentUser, serCurrentUser] = useState()
  const [loading, setLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0) 
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  const [errors, seterrors] = useState({
    rejectReason: ''
  })

  // DP_DATE_FILTER : Passes the applied date range along with existing filters when fetching dispatch plan records.
  const funcGetDispatchOrderList = async (statusVal = filterSelected, pageNum = page + 1, limitNum = rowsPerPage, searchVal = '', startDateVal = appliedStartDate, endDateVal = appliedEndDate) => {
    setLoading(true);
    try {
      const response = await getDispatchOrderList(pageNum, limitNum, statusVal, searchVal, startDateVal, endDateVal);
      if (response && response.data) {
        const bodyData = response.data.body || response.data;
        const list = bodyData.data || bodyData.rows || (Array.isArray(bodyData) ? bodyData : []);
        const count = bodyData.total !== undefined ? bodyData.total : (bodyData.count !== undefined ? bodyData.count : list.length);
        setRows(list);
        setTotalCount(count);
      }
    } catch (error) {
      console.error("Error fetching dispatch orders:", error);
    }
    setLoading(false);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handlePopUpOpen = () => {
    // setRecordForEdit(null);
    setOpenPopUp(true);
  };

  const handleReportUploadPopUpOpen = () => {
    setOpenReportUploadPopUp(true);
  };

  const handleReportUploadPopUpClose = () => {
    setOpenReportUploadPopUp(false);
  };

  const handleInvoicePopUpOpen = () => {
    setOpenInvoicePopUp(true);
  };

  const handleInvoicePopUpClose = () => {
    setOpenInvoicePopUp(false);
  };

  const handleClose = () => {
    setOpenPopUp(false);
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };
const handleChangePage = (event, newPage) => {
  setPage(newPage);
  funcGetDispatchOrderList(filterSelected, newPage + 1);
};

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

const handleChangeRowsPerPage = (event) => {
  const newRowsPerPage = parseInt(event.target.value, 10);
  setRowsPerPage(newRowsPerPage);
  setPage(0);
  // Pass the new rowsPerPage value to the API call
  funcGetDispatchOrderList(filterSelected, 1, newRowsPerPage);
};

 const getCurrentUserFunc = async () => {
  try {
    const user = await getCurrentUser();
    if (user && user.data) {
      serCurrentUser(user.data.body);
    }
  } catch (error) {
    console.error('Error fetching user:', error);
  }
};
const handleSearch = (e) => {
  let target = e.target;
  let searchTerm = target.value.trim();

  setSearchTerm(searchTerm); // DP_DATE_FILTER : Stores the current search term so it is retained when applying the date filter.
  
  console.log('Search term:', searchTerm);
  
  // Reset to page 1 for new search
  setPage(0);
  
  if (searchTerm === "") {
    // Clear search - load normal data
    funcGetDispatchOrderList(filterSelected, 1, rowsPerPage, '');
  } else {
    // Perform search - pass search term to API
    funcGetDispatchOrderList(filterSelected, 1, rowsPerPage, searchTerm);
  }
};

// DP_DATE_FILTER : Validates and applies the selected date range, resets pagination and reloads the dispatch plan list.
const handleDateFilter = () => {
  if (startDate && endDate && startDate > endDate) {
    setNotify({
      isOpen: true,
      message: 'Start date cannot be later than end date.',
      type: 'error',
    });
    return;
  }

  setAppliedStartDate(startDate);
  setAppliedEndDate(endDate);

  setPage(0);

  funcGetDispatchOrderList(
    filterSelected,
    1,
    rowsPerPage,
    searchTerm,
    startDate,
    endDate
  );
};

  const handleSyncSingleDP = async (id, refNo) => {
    setLoading(true);
    try {
      const res = await syncSingleDispatchPlanWithSAP(id);
      if (res && res.status === 1) {
        setNotify({
          isOpen: true,
          message: res.message || `SAP Data synced successfully for ${refNo}!`,
          type: 'success',
        });
        await funcGetDispatchOrderList(filterSelected, page + 1, rowsPerPage);
      } else {
        setNotify({
          isOpen: true,
          message: res.message || `Failed to sync SAP data for ${refNo}`,
          type: 'error',
        });
      }
    } catch (err) {
      setNotify({
        isOpen: true,
        message: err.message || 'Error syncing SAP data',
        type: 'error',
      });
    }
    setLoading(false);
  };
useEffect(() => {
  const loadData = async () => {
    await getCurrentUserFunc();
    await funcGetDispatchOrderList(filterSelected, 1, rowsPerPage);
  };
  loadData();
}, [filterSelected]);
  const viewUrl = (id) => {
    history.push("/dispatch-plan-details/" + id);
  };

  const renderFilterOptions = () => {
    var options = [];
    options.push(<MenuItem key={-1} value={-1}>
      All Dispatch Plans
    </MenuItem>);
    for (const key in STATUS) {
      if (STATUS.hasOwnProperty(key)) {
        const element = STATUS[key];
        options.push(<MenuItem key={element} value={element}>
          {STATUS_TEXT[key]}
        </MenuItem>);
      }
    }
    return options;
  };

  const returnStatus = status => {
    switch (status) {
      case STATUS.PENDING:
        return <Chip style={{ textTransform: 'uppercase' }} className={dpClasses.pending} label={STATUS_TEXT.PENDING} />;
      // return <button style={{textTransform:'uppercase'}} className={classes.pending}>{STATUS_TEXT.PENDING}</button>;
      case STATUS.APPROVED:
        return <Chip style={{ textTransform: 'uppercase' }} className={dpClasses.approved} label={STATUS_TEXT.APPROVED} />;
      case STATUS.REJECTED:
        return <Chip style={{ textTransform: 'uppercase' }} className={dpClasses.rejected} label={STATUS_TEXT.REJECTED} />;
      case STATUS.COMPLETED:
        return <Chip style={{ textTransform: 'uppercase' }} className={dpClasses.completed} label={STATUS_TEXT.COMPLETED} />;
      case STATUS.IN_PROGRESS:
        return <Chip style={{ textTransform: 'uppercase' }} className={dpClasses.inProgress} label={STATUS_TEXT.IN_PROGRESS} />;
      default:
        return null;
    }
  }

  const handleSalesOrderClose = () => {
    setOpenSalesOrderPopUp(false);
  };

  const handleSalesOrderPopUpOpen = id => {
    // setRecordForEdit(null);
    setDpForSalesOrder(id)
    setOpenSalesOrderPopUp(true);
  };

  const handleDownloadReportPopUpOpen = id => {
    setDownloadReportPopUp(true);
  };

  const handleDownloadReportPopUpClose = id => {
    setDownloadReportPopUp(false);
  };
//New Function to fetch data from SAP 
//New Function to fetch data from SAP 
const fetchSAPDataForRows = async (rowsList) => {
  if (!rowsList || rowsList.length === 0 || sapFetching) return;
  
  setSapFetching(true);
  const sapMap = {};
  
  // Fetch SAP data for each row with a ref_no
  for (const row of rowsList) {
    if (row.ref_no) {
      try {
        console.log(`Fetching SAP for ${row.ref_no}`);
        const response = await getSAPDataForDispatchPlan(row.ref_no);
        console.log(`Response for ${row.ref_no}:`, response);
        
        if (response && response.status === 1 && response.data) {
          // Extract the nested data
          let sapData = response.data;
          if (sapData.data) {
            sapData = sapData.data;
          }
          
          console.log('Extracted SAP data:', sapData);
          
          // Try different paths to get the sales order number
          let salesOrderNo = null;
          
          // Path 1: Direct sales_order_no field
          if (sapData.sales_order_no) {
            salesOrderNo = sapData.sales_order_no;
          }
          // Path 2: From invoices array
          else if (sapData.invoices && sapData.invoices.length > 0) {
            const firstInvoice = sapData.invoices[0];
            if (firstInvoice.items && firstInvoice.items.length > 0) {
              salesOrderNo = firstInvoice.items[0].salesOrder;
            }
          }
          // Path 3: From items array
          else if (sapData.items && sapData.items.length > 0) {
            salesOrderNo = sapData.items[0].salesOrder;
          }
          
          if (salesOrderNo) {
            sapMap[row.id] = {
              sales_order_no: salesOrderNo
            };
            console.log(`✅ Found SAP data for ${row.ref_no}:`, salesOrderNo);
          } else {
            console.log(`❌ No sales order number found for ${row.ref_no}`);
          }
        }
      } catch (error) {
        console.error(`Error fetching SAP data for ${row.ref_no}:`, error);
      }
    }
  }
  
  console.log('Final sapMap:', sapMap);
  setSapDataMap(sapMap);
  setSapFetching(false);
};
  return (
    <main className={classes.pageContent}>
      <div className={classes.toolbar} />
      <div style={{ marginBottom: "25px", marginTop: '10px' }}>
      <Grid container justifyContent="space-between" spacing={2}>
          <Grid item container xs={12} sm={6} md={3} spacing={1}>
            <Typography variant="h6" style={{ marginBottom: "10px" }}>
              All Dispatch Plans
            </Typography>
          </Grid>
          {currentUser && <> {currentUser.status === 1 &&
            <Grid>
              {
                (currentUser?.user_type === USER_TYPES.ADMIN || currentUser?.user_type === USER_TYPES.SALES_PERSON) &&
                <Button color="primary" variant="contained" style={{ marginRight: '5px' }}
                  // onClick={async () => {
                  //   let contractData = await getDispatchPlanReport();
                  //   // console.log('contractdata', contractData);
                  //   // console.log(Buffer.from(contractData.data));
                  //   const base64string = contractData.data;
                  //   const contenttype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                  //   var file = b64toBlob(base64string, contenttype);
                  //   var a = document.createElement('a'),
                  //     file;
                  //   a.href = window.URL.createObjectURL(file);
                  //   a.target = '_blank';
                  //   a.download = 'DP-Report-' + new Date().toDateString() + '.xlsx';
                  //   document.body.appendChild(a);
                  //   a.click();
                  //   document.body.removeChild(a);
                  // }}
                  onClick={handleDownloadReportPopUpOpen}
                >
                  Download Report
                </Button>
              }
              {currentUser.user_type !== USER_TYPES.DISTRIBUTOR &&
                <Button color="primary" variant="contained" style={{ marginRight: '5px' }}
                  onClick={handleReportUploadPopUpOpen}
                >
                  Upload Report
                </Button>
              }
              {
                (currentUser?.user_type === USER_TYPES.ADMIN || currentUser.user_type === USER_TYPES.SALES_PERSON) &&
                <Button color="primary" variant="contained" style={{ marginRight: '5px' }}
                  onClick={handleInvoicePopUpOpen}
                >
                  Upload Invoice Data
                </Button>
              }
              {currentUser.user_type !== USER_TYPES.SALES_PERSON &&
                <Button color="primary" variant="contained"
                  onClick={handlePopUpOpen}
                >
                  New Dispatch Plan
                </Button>
              }
            </Grid>
          }</>}
        </Grid>
      </div>
      <Paper style={{ paddingTop: "15px", paddingBottom: '15px' }}>
        <Toolbar>
          {/* <div style={{ marginBottom: "20px" }}> */}
         <Grid container justifyContent="space-between" spacing={0}>
            <Grid item xs={12} sm={12} md={9}>
              <Input
                label="Search by Organization name or reference no."
                className={classes.searchInput}
                style={{ width: '75%' }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
              />
            </Grid>
            <Grid >
              <FormControl variant="outlined"
                style={{ marginTop: '5px' }}
              >
                <InputLabel id="demo-mutiple-name-label">Filters</InputLabel>
                <MaterialUISelect
                  labelId="demo-mutiple-name-label"
                  name="Filters"
                  label="Filters"
                  value={filterSelected}
                  MenuProps={MenuProps}
onChange={(e) => { 
  const selectedFilter = e.target.value;
  setFilterSelected(selectedFilter);
  funcGetDispatchOrderList(selectedFilter, 1, rowsPerPage); 
  setPage(0);
}}
                >
                  {renderFilterOptions()}
                </MaterialUISelect>
              </FormControl>
            </Grid>
          </Grid>
          {/* </div> */}
        </Toolbar>
                  {/* DP_DATE_FILTER : Displays the start-date and end-date selectors and the Filter button for applying the date range. */}
                <Grid
          container
          spacing={2}
          alignItems="center"
          style={{ padding: '10px 20px' }}
        >
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              variant="outlined"
              size="small"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <TextField
              fullWidth
              type="date"
              label="End Date"
              variant="outlined"
              size="small"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} sm={4} md={2}>
            <Button
              color="primary"
              variant="contained"
              onClick={handleDateFilter}
              fullWidth
            >
              Filter
            </Button>
          </Grid>
        </Grid>
      </Paper>


      <div className={classes.root}>
        <Paper className={classes.container}>
          {loading === false ? <> <TableContainer className={classes.tableContainer} style={{ textAlign: "center" }}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                numSelected={0}        
  onSelectAllClick={() => {}}
              />
             <TableBody>
  {rows.length > 0 ? (
    rows.map((row, index) => {
        const labelId = `enhanced-table-checkbox-${index}`;
        return (
          <TableRow hover tabIndex={-1} key={row.id}>
            <TableCell component="th" id={labelId} scope="row">
              {formatDate(row.date || row.created)}
            </TableCell>
            <TableCell align="right">{row.org_name}</TableCell>
            <TableCell align="right">{row.ref_no && row.ref_no.toUpperCase()}</TableCell>
            <TableCell align="right">{row.po_ref_no.toUpperCase()}</TableCell>
   <TableCell align="right">
  {row.sap_sales_order_no || row.sap_sales_order_id || "   --"}&nbsp;&nbsp;
  {row.sales_order_filename && (
    <Link
      onClick={async () => {
        let salesOrderData = await getSalesOrderFile(row.sales_order_filename);
        const blob = new Blob([salesOrderData], { type: 'application/pdf' });
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${row.sales_order_filename || 'SalesOrder'}`;
        a.click();
      }}
      style={{ cursor: 'pointer' }}
    >
      <AttachFileIcon fontSize="small" />
    </Link>
  )}
</TableCell>
            <TableCell align="right">{row.total_materials}</TableCell>
            <TableCell align="right">{row.total_quantity}</TableCell>
          <TableCell align="right">
  <div className={classes.textDark}>
    {(() => {
      const sapQuantity = row.sap_quantity;
      const totalQuantity = row.total_quantity;
      const isQuantityMatch = sapQuantity && 
        Math.abs(parseFloat(sapQuantity) - parseFloat(totalQuantity)) < 0.01;
      
      if (isQuantityMatch) {
        return returnStatus(STATUS.COMPLETED);
      }
      return returnStatus(row.status);
    })()}
  </div>
</TableCell>
            <TableCell>
              <ActionButton color="primary" title="View Details">
                <VisibilityIcon onClick={() => viewUrl(row.id)} fontSize="small" />
              </ActionButton>
              {row.status === STATUS.APPROVED && 
               (currentUser?.user_type === USER_TYPES.ADMIN || 
                currentUser?.user_type === USER_TYPES.SALES_PERSON) && (
                <ActionButton color="primary" title="Edit Sales Order">
                  <SettingsIcon onClick={() => handleSalesOrderPopUpOpen(row.id)} fontSize="small" />
                </ActionButton>
              )}
              {(() => {
                const sapQuantity = row.sap_quantity;
                const totalQuantity = row.total_quantity;
                const isQuantityMatch = sapQuantity && 
                  Math.abs(parseFloat(sapQuantity) - parseFloat(totalQuantity)) < 0.01;
                const isCompleted = isQuantityMatch || row.status === STATUS.COMPLETED;
                const isRejected = row.status === STATUS.REJECTED;

                if (row.ref_no && !isCompleted && !isRejected) {
                  return (
                    <ActionButton color="primary" title="Sync SAP Data">
                      <SyncIcon onClick={() => handleSyncSingleDP(row.id, row.ref_no)} fontSize="small" />
                    </ActionButton>
                  );
                }
                return null;
              })()}
            </TableCell>
          </TableRow>
        );
      })
  ) : (
    <TableRow>
      <TableCell colSpan={9} align="center">
        {loading ? 'Loading...' : 'No data available'}
      </TableCell>
    </TableRow>
  )}
  {emptyRows > 0 && (
    <TableRow style={{ height: 53 * emptyRows }}>
      <TableCell colSpan={9} />
    </TableRow>
  )}
</TableBody>
            </Table>
         </TableContainer>
<TablePagination
  rowsPerPageOptions={[5, 10, 25, 50]}
  component="div"
  count={totalCount}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
/></> : <>
            <CircularProgress />
          </>}
        </Paper>
        <Grid item xs={12}>
          <Dialog
            heading="Create New Dispatch Plan"
            handleClose={handleClose}
            open={openPopUp}
            width="md"
          >
            <SelectDistributorAndPO
            // type={typeModal}
            // recordForEdit={recordForEdit}
            />
          </Dialog>
        </Grid>
        <Grid item xs={12}>
          <Dialog
            heading="Edit Sales Order Details"
            handleClose={handleSalesOrderClose}
            open={openSalesOrderPopUp}
            width="md"
          >
            <EditSalesOrderDetails
              dpId={dpForSalesOrder}
              handleClose={handleSalesOrderClose}
              setNotify={setNotify}
              updateDPList={funcGetDispatchOrderList}
            />
          </Dialog>
        </Grid>
        <Grid item xs={12}>
          <Dialog
            heading="Upload Invoice Data in Excel File"
            handleClose={handleInvoicePopUpClose}
            open={openInvoicePopUp}
            width="md"
          >
            <UploadInvoiceData
              dpId={dpForSalesOrder}
              handleClose={handleInvoicePopUpClose}
              setNotify={setNotify}
              updateDPList={funcGetDispatchOrderList}
            />
          </Dialog>
        </Grid>
        <Grid item xs={12}>
          <Dialog
            heading="Upload DP Report in Excel File"
            handleClose={handleReportUploadPopUpClose}
            open={openReportUploadPopUp}
            width="md"
          >
            <UploadReportFile
              dpId={dpForSalesOrder}
              handleClose={handleReportUploadPopUpClose}
              setNotify={setNotify}
              updateDPList={funcGetDispatchOrderList}
            />
          </Dialog>
        </Grid>
        <Grid item xs={12}>
          <Dialog
            heading="Download All DP Report"
            handleClose={handleDownloadReportPopUpClose}
            open={downloadReportPopUp}
            width="sm"
          >
            <DownloadReport
              dpId={dpForSalesOrder}
              handleClose={handleDownloadReportPopUpClose}
              setNotify={setNotify}
              updateDPList={funcGetDispatchOrderList}
              start_date={appliedStartDate}
              end_date={appliedEndDate}
            />
          </Dialog>
        </Grid>
      </div>
      <Notifications notify={notify} setNotify={setNotify} />
    </main>
  );
};

export default withStyles(cssStyles)(DispatchPlanList);
